const constants = require('@/util/constants')
require('./config')

/**
 * 分页加载客户资料
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function queryCustomers(page, size, successcb, failedcb) {
  axios.get('/api/crm/query', {
    params: {
      'page': page,
      'size': size,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 根据会话tid查询-客户资料
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function getCustomer (tid, successcb, failedcb) {
  axios.get('/api/crm/get', {
    params: {
      'tid': tid,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 根据访客uid查询-客户资料
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function getCustomerByUid(uid, successcb, failedcb) {
  axios.get('/api/crm/get/uid', {
    params: {
      'uid': uid,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 创建会话小结
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function createCustomer (crm, successcb, failedcb) {
  axios.post('/api/crm/create', {
    'cid': crm.cid,
    'name': crm.name,
    'email': crm.email,
    'mobile': crm.mobile,
    'age': crm.age,
    'job': crm.job,
    'company': crm.company,
    'description': crm.description,
    'tid': crm.tid,
    'tags': crm.tags,
    'client': constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 更新会话小结
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function updateCustomer (crm, successcb, failedcb) {
  axios.post('/api/crm/update', {
    'cid': crm.cid,
    'name': crm.name,
    'email': crm.email,
    'mobile': crm.mobile,
    'age': crm.age,
    'job': crm.job,
    'company': crm.company,
    'description': crm.description,
    'tid': crm.tid,
    'tags': crm.tags,
    'client': constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 删除会话小结
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function deleteCustomer (id, successcb, failedcb) {
  axios.post('/api/crm/delete', {
    id,
    'client': constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}
